// Original hypothetical scenarios. Rates, timing and fee conventions are explicit in each question.
export const methodsReview = {
  moduleId: 'methods',
  title: '投入時間、平均成本與費用一起看',
  questions: [
    {
      id: 'methods-fixed-amount-unit-cost',
      lessonId: 'dca-mechanics',
      question: '兩次各投入 1,200 元，買進價格依序為每單位 60 元、40 元。假設可買零碎單位且沒有費用，合計每單位平均買進成本是多少？',
      options: ['50 元，因為兩次價格的算術平均是 50', '48 元，因為總投入 2,400 元買到 50 單位', '40 元，因為後來一次比較便宜'],
      answer: 1,
      explanation: '第一次買 1,200 ÷ 60＝20 單位，第二次買 1,200 ÷ 40＝30 單位；平均成本＝2,400 ÷ 50＝48 元。固定金額在較低價格買到較多單位，因此不能直接平均兩個價格。平均成本較低也不保證最後賣出時獲利。',
    },
    {
      id: 'methods-cash-flow-and-return',
      lessonId: 'time-weighted-return',
      question: '期初投入 20,000 元，第一期上漲 20% 至 24,000 元；期末立刻再投入 76,000 元，第二期從 100,000 元下跌 10% 至 90,000 元。無其他現金流或費用，哪個敘述正確？',
      options: [
        '兩期累計 TWR 為 −6.25%，就是期末價值除以所有投入再減 1',
        '兩期累計 TWR 為 5%，就是把 +20% 與 −10% 平均',
        '兩期累計 TWR 為 +8%；MWR 還會反映追加資金的金額與時點',
      ],
      answer: 2,
      explanation: '將外部投入前後切成兩期，再連乘：（1＋20%）×（1−10%）−1＝8%，這是兩期累計、未年化的 TWR。個人總投入 96,000 元、期末僅 90,000 元，現金損益為負；因為較大筆資金參與了第二期下跌，這不與正的 TWR 矛盾。若要算年化 MWR，還需要各筆資金的實際日期與期間。',
    },
    {
      id: 'methods-contribution-insufficient',
      lessonId: 'rebalancing-contributions',
      question: '假想組合目前股票 70,000 元、債券 30,000 元，練習目標為股票 60%、債券 40%。只能追加 10,000 元並全部投入這兩類資產，不能賣出，假設價格不變且無費用，能精確達標嗎？',
      options: [
        '不能；就算新增資金全買債券，股票仍占約 63.64%',
        '可以；新增的 10,000 元全買債券後，比例正好是 60%／40%',
        '可以；只要把新增資金照 60%／40% 分配，整體就會同步達標',
      ],
      answer: 0,
      explanation: '投入後總額為 110,000 元，60% 的股票目標金額是 66,000 元，但既有股票已達 70,000 元且不能賣出。把新增資金全放債券時，股票比重已是最低的 70,000 ÷ 110,000≈63.64%。新資金能縮小偏離，但金額不足時不能保證一次恢復精確比例；60%／40% 僅為題目假設。',
    },
    {
      id: 'methods-fee-compounding-order',
      lessonId: 'fee-compounding',
      question: '假設本金 10,000 元，連續兩年每年先增加 8%，再於年底按當時資產扣除 1% 費用，沒有其他投入、提款或稅。依這個明訂模型，兩年後約有多少？',
      options: ['11,664.00 元', '11,431.89 元', '11,449.00 元'],
      answer: 1,
      explanation: '每年淨成長因子為 1.08 × 0.99＝1.0692，兩年後為 10,000 × 1.0692²≈11,431.89 元。11,664 元完全沒扣費，11,449 元則把淨報酬直接當成 8%−1%＝7%。本題按年末資產扣費，必須照順序相乘；真實商品的計費頻率與基礎應讀費用說明，不一定採這個模型。',
    },
  ],
};
